import React from 'react'
import styled from 'styled-components'

export interface SettingsStatItem {
  value: React.ReactNode
  label: string
}

interface Props {
  items: SettingsStatItem[]
}

export const SettingsStatGrid: React.FC<Props> = ({ items }) => (
  <Grid>
    {items.map(item => (
      <StatItem key={item.label}>
        <StatLabel>{item.label}</StatLabel>
        <StatValue>{item.value}</StatValue>
      </StatItem>
    ))}
  </Grid>
)

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: ${({ theme }) => theme.spacing.sm}rem;

  @media (max-width: 1040px) {
    grid-template-columns: 1fr;
  }
`

const StatItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.xxs}rem;
  min-width: 0;
  padding: ${({ theme }) => theme.spacing.md}rem;
  border-radius: ${({ theme }) => theme.borderRadius.md}rem;
  background: ${({ theme }) => theme.colors.neutralGray};
`

const StatLabel = styled.span`
  font-size: ${({ theme }) => theme.fontSize.sm}rem;
  color: ${({ theme }) => theme.colors.metalGray};
  overflow-wrap: anywhere;
`

const StatValue = styled.span`
  font-size: ${({ theme }) => theme.fontSize.lg}rem;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.neutralBlack};
  font-variant-numeric: tabular-nums;
`
